/**
 * Marca dos briefings montados com dados reais (`realReports.ts`). Arquivo leve, sem as fontes reais:
 * a tela Relatórios usa só isto para separar o real do que chegou da simulação pelo stream.
 */
import type { Briefing } from '@rota/contracts';

/** Prefixo dos briefings montados com dados reais. */
export const REAL_BRIEFING_PREFIX = 'brf_real_';

/** O briefing veio dos dados reais (e não da simulação)? */
export function isRealBriefing(b: Pick<Briefing, 'id'>): boolean {
  return b.id.startsWith(REAL_BRIEFING_PREFIX);
}
